export const skillsData = [
  {
    label: "FRONTEND",
    data: [
      {
        skillName: "HTML",
        percentage: "90",
      },
      {
        skillName: "CSS",
        percentage: "50",
      },
      {
        skillName: "JAVASCRIPT",
        percentage: "80",
      },
      {
        skillName: "REACT",
        percentage: "85",
      },
      {
        skillName: "ANGULAR",
        percentage: "30",
      },
      {
        skillName: "TYPESCRIPT",
        percentage: "30",
      },
      {
        skillName: "JQUERY",
        percentage: "60",
      },
      {
        skillName: "SASS",
        percentage: "64",
      },
      {
        skillName: "BOOTSTRAP",
        percentage: "80",
      },
    ],
  },
  {
    label: "BACKEND",
    data: [
      {
        skillName: "JAVA",
        percentage: "85",
      },
      {
        skillName: "C#",
        percentage: "75",
      },
      {
        skillName: "ASP.NET",
        percentage: "65",
      },
      {
        skillName: "NODE JS",
        percentage: "75",
      },
      {
        skillName: "SOLIDITY",
        percentage: "65",
      },
    ],
  },
  {
    label: "DATABASES",
    data: [
      {
        skillName: "MYSQL",
        percentage: "35",
      },
      {
        skillName: "MONGODB",
        percentage: "40",
      },
      {
        skillName: "MONGODB",
        percentage: "40",
      },
      {
        skillName: "ORACLE",
        percentage: "70",
      },
      {
        skillName: "MICROSOFT SQL SERVER",
        percentage: "40",
      },
    ],
  },
];
